import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { getMobileOS } from "../../../utils/detect-mobile";
import { isNullOrUndefined } from "../../../utils/fn";
var isAndroid = getMobileOS() === 'android';

/**
 * Returns position of caret on given input element `domNode`
 * @param domNode {HTMLInputElement} - input element that we read cursor position from
 */
export var getCursorPosition = function getCursorPosition(domNode) {
  var iCaretPos = 0;
  if (document.selection) {
    domNode.focus();
    var oSel = document.selection.createRange();
    oSel.moveStart('character', -domNode.value.length);
    iCaretPos = oSel.text.length;
  } else if (domNode.selectionStart || domNode.selectionStart === '0') {
    iCaretPos = domNode.selectionStart;
  }
  return iCaretPos;
};
export var getCursorSelectionLength = function getCursorSelectionLength(domNode) {
  var selLength = 0;
  if (document.selection) {
    domNode.focus();
    var oSel = document.selection.createRange();
    selLength = oSel.text.length;
  } else if (typeof domNode.selectionStart === 'number' || domNode.selectionStart === '0') {
    selLength = domNode.selectionEnd - domNode.selectionStart;
  }
  return selLength;
};

/**
 * Given input element `domNode`, sets caret on `caretPos`
 * @param domNode {HTMLInputElement} - input element that we set cursor on
 * @param caretPos {number} - position of caret to set cursor on
 */
export var setCursorPosition = function setCursorPosition(domNode, caretPos) {
  if (typeof caretPos === 'undefined') return;
  if (domNode.createTextRange) {
    var range = domNode.createTextRange();
    range.move('character', caretPos);
    range.select();
  } else if (domNode.setSelectionRange) {
    if (isAndroid) {
      setTimeout(function () {
        domNode.setSelectionRange(caretPos, caretPos);
      }, 5);
    } else {
      domNode.setSelectionRange(caretPos, caretPos);
    }
  }
};

/**
 * Find position of `needle`'s `number` occurrence in `haystack`
 * @param haystack {Array} - string to conduct search in
 * @param needle {string} - a string to search for
 * @param number {number} - occurrence number, starting from 0 (first)
 */
export var getPositionOfOccurrence = function getPositionOfOccurrence(haystack, needle, number) {
  var position = -1;
  do {
    position = haystack.indexOf(needle, position + 1);
    number -= 1;
  } while (position !== -1 && number >= 0);
  return position;
};

/**
 * fake event is used to imitate onChange-compatible events
 */
export var fakeChangeEvent = function fakeChangeEvent(event, value) {
  return _objectSpread(_objectSpread({}, event), {}, {
    target: _objectSpread(_objectSpread({}, event.target), {}, {
      value: value
    })
  });
};
export var valueToString = function valueToString(value) {
  return !isNullOrUndefined(value) ? value.toString() : '';
};
export var valueToPixel = function valueToPixel(value) {
  return isNullOrUndefined(value) ? null : "".concat(value, "px");
};